/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Field_BlockInputs */

const vi_media_field_block = /** @type {(inputs: Media_Field_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nội dung khối`)
};

/**

* @param {Media_Field_BlockInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_field_block = /** @type {((inputs?: Media_Field_BlockInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Field_BlockInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_field_block(inputs)
});